import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — an exterior concrete panel wall segment: concrete grey with
// thin darker reveal lines marking the panel joints. Same dimensions as
// wall-plain (1 m long, 0.12 thick, 2.6 high, along X through the tile
// centre).
const CONCRETE = "#9a9a94";
const REVEAL = "#82827c";

export const wallConcrete = defineModel({
  id: "wall-concrete",
  batchId: "modern",
  name: "Concrete wall",
  tags: ["modern", "outdoor", "structure", "wall", "concrete", "exterior"],
  summary: "An exterior concrete panel wall with recessed reveal lines.",
  description:
    "A one-tile exterior concrete panel wall of the Modern Living kit: " +
    "concrete grey with thin darker horizontal reveal lines at the panel " +
    "joints, 0.12 m thick and 2.6 m high, running along X through the tile " +
    "centre like every wall piece.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // the concrete panel body
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.12), color: CONCRETE, position: [0, 1.3, 0] },
      // thin darker reveal lines, slightly proud of both faces so they read
      { geometry: new THREE.BoxGeometry(1.0, 0.025, 0.13), color: REVEAL, position: [0, 0.87, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.025, 0.13), color: REVEAL, position: [0, 1.73, 0] },
    ];
  },
  animations: [],
});
